import { Injectable } from '@angular/core';

import { GetMiniHomeV3Request, MiniHome } from '@proto/store/api/store/home';
import { LativHttpClient } from '@service/lativ.interceptor';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MiniRepositoryService {
  constructor(private http: LativHttpClient) {}

  getMiniHomeV3(req: GetMiniHomeV3Request): Observable<MiniHome> {
    return this.http
      .get(
        'v3/home/mini',
        req.category
          ? {
              params: GetMiniHomeV3Request.toJSON(req) as {
                [param: string]: string;
              },
            }
          : undefined
      )
      .pipe(map(res => MiniHome.fromJSON(res)));
  }
}
